import React, { useState } from "react";
import { Target } from "lucide-react";
import { Badge } from "../ui/badge";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "../ui/card";
import { CollectionTargetsEditor } from "./CollectionTargetsEditor";

/** Phase 214 — Admin → Settings card: month-wise collection targets per Financial Year (drawn on the dashboard graph). */
const money = (n) => "\u20B9" + Number(n || 0).toLocaleString("en-IN", { maximumFractionDigits: 0 });

export function CollectionTargetsCard({ code, readOnly = false, testIdPrefix = "settings-collection-targets", className = "" }) {
  const [summary, setSummary] = useState(null);   // last saved payload (for the header badge)
  return (
    <Card className={`shadow-sm ${className}`} data-testid={`${testIdPrefix}-card`}>
      <CardHeader className="pb-2">
        <CardTitle className="text-base font-heading flex items-center gap-2 flex-wrap">
          <Target className="h-4 w-4" /> Monthly collection targets
          {summary && (
            <Badge variant="outline" className={`tabular-nums ${summary.has_targets ? "bg-emerald-50 text-emerald-700 border-emerald-200" : "bg-slate-100 text-slate-600 border-slate-200"}`} data-testid={`${testIdPrefix}-summary-badge`}>
              FY {summary.fy?.fy_label}: {summary.has_targets ? `${money(summary.annual_total)} annual target` : "no targets set"}
            </Badge>
          )}
        </CardTitle>
        <CardDescription className="text-xs">
          Enter the collection target (₹) for each month of a Financial Year. The Monthly Collection graph on the Admin and Super Admin
          dashboards draws these as a dashed target line over the bars, and the tooltip shows how far each month is from its target.
          Use the annual quick fill to split a yearly figure evenly, then fine-tune individual months. Leave a month blank for no target.
        </CardDescription>
      </CardHeader>
      <CardContent>
        <CollectionTargetsEditor code={code} readOnly={readOnly} testIdPrefix={testIdPrefix} onSaved={setSummary} onLoaded={setSummary} />
      </CardContent>
    </Card>
  );
}
